export default {
    intro: 'Put the jumbled sentences in the correct order!',
    indicator: ({ values }: { values: { isAllDone: boolean } }) => {
        const { isAllDone } = values;
        if (isAllDone) {
            return 'Read the completed text once more.';
        }
        return 'Put the sentences in the correct order!';
    },
    retry: ({ values }: { values: { count: number } }) =>
        `Almost! ${values.count} sentence(s) aren't in place yet. You have one more try — give it another go!`,
    exhausted: "Here's the answer! You'll get it next time.",
    viewCompleted: 'View completed text',
    table: {
        question: 'Question',
        answerRate: 'Accuracy',
        emptyMessage: 'No content available.',
    },
    roundNumber: 'No. {number}',
};
